<section class="gradient-section-theme-color1">
  <div class="container">
    <h1>
      Discount Calculator
    </h1>
  </div>
</section>

<div class="col-xs-12" style="height:50px;"></div>

<div class="container">
  <nav aria-label="breadcrumb">
    <ol class="breadcrumb">
      <li class="breadcrumb-item"><a href="/">Home</a></li>
      <li class="breadcrumb-item"><a href="/tools">Tools</a></li>
      <li class="breadcrumb-item active" aria-current="page">Discount Calculator</li>
    </ol>
  </nav>

  <div class="mt-5">
    <div class="discount-calculator">
      <p>Use this tool to calculate the final price after applying a discount. Enter the original price and the
      discount percentage, then click the "Calculate Discount" button to see your result.</p>

      <form [formGroup]="discountForm" (ngSubmit)="calculateDiscount()" class="discount-form">
        <div class="form-group">
          <label for="originalPrice">Original Price ($/...):</label>
          <input type="number" id="originalPrice" formControlName="originalPrice" class="form-control"
            required>
        </div>
        <div class="form-group">
          <label for="discountPercentage">Discount Percentage (%):</label>
          <input type="number" id="discountPercentage" formControlName="discountPercentage"
            class="form-control" required>
        </div>
        <div class="form-group mt-3">
          <button type="submit" class="btn btn-primary">Calculate Discount</button>
        </div>
      </form>
      <div class="col-xs-12" style="height:50px;"></div>

      @if (discountResult !== null) {
        <div>
          <div>The final price after discount is: <strong>${{ discountResultStr }}</strong>($/..)</div>
        </div>
      }
    </div>
  </div>
</div>

<div class="col-xs-12" style="height:50px;"></div>
